import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  cancelSubscription,
  fetchBillingAccess,
  fetchBillingOverview,
  updatePaymentMethod,
} from '../api/billing'
import { queryKeys } from '../api/queryKeys'

type BillingSessionInput = {
  currentUserTypeId?: number
  currentClientTypeId?: number
  advisorId?: string | null
  platformType?: number[]
}

export function useBillingOverview(clientId: string, session: BillingSessionInput) {
  return useQuery({
    queryKey: queryKeys.billing.overview(clientId),
    queryFn: () => fetchBillingOverview(clientId, session),
    enabled: !!clientId,
  })
}

export function useBillingAccess(clientId: string) {
  return useQuery({
    queryKey: queryKeys.billing.access(clientId),
    queryFn: () => fetchBillingAccess(clientId),
    enabled: !!clientId,
  })
}

export function useCancelSubscriptionMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: { subscriptionId: string }) => cancelSubscription({ clientId, ...input }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.overview(clientId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.adviceprep.liveSubscription(clientId) })
    },
  })
}

export function useUpdatePaymentMethodMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: { paymentId: string }) => updatePaymentMethod({ clientId, ...input }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.overview(clientId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.adviceprep.liveSubscription(clientId) })
    },
  })
}

